import { FeatureTogglePort } from '@otto-ec/eprivacy-shared'

export const IS_ONETRUST_INTERNAL_HOSTING_ENABLED_TOGGLE_KEY =
  'cb_onetrust_internal_hosting'

export function isOneTrustInternalHostingEnabled(
  featureTogglePort: FeatureTogglePort
) {
  return featureTogglePort(
    IS_ONETRUST_INTERNAL_HOSTING_ENABLED_TOGGLE_KEY,
    false
  )
}
